import React from 'react'
import PropTypes from 'prop-types'

// hixme-ui
import Input from '@hixme-ui/input'
import Text from '@hixme-ui/text'

// project
import { hasError } from 'modules/redux-form-utils'
import { FieldError } from 'components/ReduxFormComponents'

const FieldInput = (props) => {
  const { input, meta, ...restProps } = props
  return (
    <div>
      <Input error={hasError(meta)} {...input} {...restProps} />
      <FieldError meta={meta}>{(error) => <Text error>{error}</Text>}</FieldError>
    </div>
  )
}
FieldInput.displayName = 'FieldInput'
FieldInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default FieldInput
